// The fixed header moves continuously with scroll, without direction toggles.
const header = document.querySelector('#header-group > .header-section');
if (header) {
  let frame;
  const update = () => {
    frame = undefined;
    const travel = Math.min(header.offsetHeight,Math.max(0,window.scrollY) * .6);
    header.style.setProperty('--orimodo-header-shift',`${-travel}px`);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  addEventListener('pageshow',schedule);
  update();
}

// Keep theme previews and selected media when following a details-view link.
const params = new URLSearchParams(location.search);
document.querySelectorAll('[data-product-return]').forEach(link => {
  const url = new URL(link.href);
  const preview = params.get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id',preview);
  try {
    const saved = JSON.parse(sessionStorage.getItem('orimodo-product-scroll') || 'null');
    if (saved?.path === url.pathname && saved.media) {
      url.searchParams.set('media',saved.media);
      link.addEventListener('click',() => sessionStorage.setItem('orimodo-product-return','1'));
    }
  } catch {}
  link.href = url.toString();
});
if (document.querySelector('.opd')) {
  try {
    if (sessionStorage.getItem('orimodo-product-return') === '1') {
      sessionStorage.removeItem('orimodo-product-return');
      const saved = JSON.parse(sessionStorage.getItem('orimodo-product-scroll') || 'null');
      if (saved?.path === location.pathname) {
        addEventListener('load',() => requestAnimationFrame(() => scrollTo({top:saved.y,behavior:'instant'})),{once:true});
      }
    }
  } catch {}
}
